import { createSlice } from "@reduxjs/toolkit";

interface ChainInventoryFilterState {
  isFilterActive: boolean;
}

const initialState: ChainInventoryFilterState = {
  isFilterActive: false,
};

const chainInventoryFilterSlice = createSlice({
  name: "chainInventoryFilter",
  initialState,
  reducers: {
    toggleInventoryFilter(state) {
      state.isFilterActive = !state.isFilterActive;
    },
    setInventoryFilter(state, action) {
      state.isFilterActive = action.payload;
    },
  },
});

export const { toggleInventoryFilter, setInventoryFilter } = chainInventoryFilterSlice.actions;
export default chainInventoryFilterSlice.reducer;
